<div style="display: flex; flex-direction: column; height: 100%">
    <div fxFlex style="height: 100px">
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxHide.lt-md fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">Pilot Activity</span>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div style="padding: 10px; height: calc(100% - 100px)">
        <mat-card style="height: 100%; display: flex; flex-direction: column">
            <div style="height: 100px; display: flex; flex-direction: row; justify-content: space-between">
                <kendo-datepicker
                    activeView="year"
                    bottomView="year"
                    format="MMMM yyyy"
                    style="width: 160px; margin: 20px"
                    [(value)]="selectedDate"
                    (valueChange)="onDateChange($event)"
                    [max]="today"
                >
                </kendo-datepicker>
                <button mat-raised-button color="primary" style="margin: 20px" (click)="grid.saveAsExcel()">
                    <mat-icon>download</mat-icon>
                    Export
                </button>
            </div>
            <div style="height: calc(100% - 100px); padding: 10px">
                <kendo-grid #grid="kendoGrid" [data]="pilotActivityList" (excelExport)="onExcelExport($event)">
                    <kendo-grid-column field="day" title="Day" [sticky]="true" [width]="50">
                        <ng-template kendoGridFooterTemplate>
                            <span> Totals </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="date" title="Date" [sticky]="true" [width]="100">
                        <ng-template kendoGridFooterTemplate>
                            <span> (Days / Hours): </span>
                        </ng-template>
                    </kendo-grid-column>
                    @for (pilot of pilotList; track pilot.id) {
                        <kendo-grid-column-group title="{{ pilot.name }}" class="group-separator">
                            <kendo-grid-column [field]="pilot.name + '.daily'" title="Day" [style]="{ 'text-align': 'center' }" [width]="60">
                                <ng-template kendoGridFooterTemplate>
                                    <div class="footer-value true-count" style="text-align: center">
                                        {{ sumOccurences(pilot.name) }}
                                    </div>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column [field]="pilot.name + '.weekly'" title="Week" [style]="{ 'text-align': 'center' }" [width]="60" class="group-separator-cell">
                                <ng-template kendoGridFooterTemplate>
                                    <div class="footer-value true-count" style="text-align: center">
                                        {{ sumHours(pilot.name) }}
                                    </div>
                                </ng-template>
                            </kendo-grid-column>
                        </kendo-grid-column-group>
                    }
                    <kendo-grid-excel [fileName]="getFileName()">
                        @let matPrimaryColor = "#4050b5";
                        <kendo-excelexport-column field="day" title="Day" [width]="50" [headerCellOptions]="{ background: matPrimaryColor }"></kendo-excelexport-column>
                        <kendo-excelexport-column field="date" title="Date" [width]="120" [headerCellOptions]="{ background: matPrimaryColor }"></kendo-excelexport-column>
                        @for (pilot of pilotList; track pilot) {
                            <kendo-excelexport-column-group
                                title="{{ pilot.name }}"
                                [style]="{ 'text-align': 'center' }"
                                [width]="120"
                                [headerCellOptions]="{ background: matPrimaryColor }"
                            >
                                <kendo-excelexport-column [field]="pilot.name + '.daily'" title="Day" [width]="60" [headerCellOptions]="{ background: matPrimaryColor }">
                                    <ng-template kendoExcelExportFooterTemplate>
                                        <div class="footer-value true-count">
                                            {{ sumOccurences(pilot.name) }}
                                        </div>
                                    </ng-template>
                                </kendo-excelexport-column>
                                <kendo-excelexport-column
                                    [field]="pilot.name + '.weekly'"
                                    title="week"
                                    [style]="{ 'text-align': 'center' }"
                                    [width]="60"
                                    [headerCellOptions]="{ background: matPrimaryColor }"
                                >
                                    <ng-template kendoExcelExportFooterTemplate>
                                        <div class="footer-value true-count">
                                            {{ sumHours(pilot.name) }}
                                        </div>
                                    </ng-template>
                                </kendo-excelexport-column>
                            </kendo-excelexport-column-group>
                        }
                    </kendo-grid-excel>
                </kendo-grid>
            </div>
        </mat-card>
    </div>
</div>
